import { AuthLayout } from '@trellistry/ui';
import { useState } from 'react';
import { finishGrant } from '../api.js';
import { AuthenticatorStep, BackupCodesStep, PasswordStep } from './NewDetails.js';

/**
 * First sign-in (design §5): the person replaces the password they were given, sets up their authenticator app and
 * keeps their backup codes. They then sign in as usual, which is the only way to a session; a passkey can be added
 * after that, under My sign-in.
 */
export function Setup({ grantId, onDone, onExpired }: { grantId: string; onDone: () => void; onExpired: () => void }) {
  const [step, setStep] = useState<'password' | 'authenticator' | 'codes'>('password');
  const [codes, setCodes] = useState<string[]>([]);
  return (
    <AuthLayout>
      {step === 'password' && <PasswordStep grantId={grantId} onDone={() => setStep('authenticator')} onExpired={onExpired} />}
      {step === 'authenticator' && <AuthenticatorStep grantId={grantId} onExpired={onExpired} onConfirmed={(c) => { setCodes(c); setStep('codes'); }} />}
      {step === 'codes' && <BackupCodesStep codes={codes} doneLabel="Finish" onDone={async () => { await finishGrant(grantId).catch(() => undefined); onDone(); }} />}
    </AuthLayout>
  );
}
